export default "__VITE_ASSET__B2h1G72d__"